import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import ChecksTable from 'dashboard/components/ChecksTable';
import Divider from 'dashboard/components/Divider';
import { VerificationDetailProps } from 'dashboard/components/VerificationDetail/types';
import { Check } from 'dashboard/models/check';
import { VerificationDatabaseVatNumber } from 'dashboard/models/verification';
import Attribute, { AttributeGrid } from 'design-system/components/Attribute';
import { Heading } from 'design-system/components/Text';
import { VerificationStatus } from 'lib/verification';

const StyledAttributeGrid = styled(AttributeGrid)`
  padding: 0 ${Spacing[4]} ${Spacing[2]};
`;

const ChecksInformationRow = styled('div')`
  display: grid;
  grid-template-columns: auto;
  grid-row-gap: ${Spacing[4]};
`;

interface DatabaseVerificationVatNumberProps extends VerificationDetailProps {
  verification: VerificationDatabaseVatNumber;
}

const ChecksHeaderContainer = styled('div')`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  padding: 0 ${Spacing[3]};
`;

const TitleContainer = styled('div')`
  justify-self: start;
`;

const ChecksHeader = ({ title }: { title: string }) => {
  return (
    <ChecksHeaderContainer>
      <TitleContainer>
        <Heading size='sm'>{title}</Heading>
      </TitleContainer>
    </ChecksHeaderContainer>
  );
};

const DatabaseVatNumberVerification = ({ verification }: DatabaseVerificationVatNumberProps) => {
  const {
    'country-code': countryCode,
    'vat-number': vatNumber,
    'redacted-at': redactedAt,
    'business-name': businessName,
    'address-street-1': addressStreet1,
    'address-street-2': addressStreet2,
    'address-city': addressCity,
    'address-subdivision': addressSubdivision,
    'address-postal-code': addressPostalCode,
    checks,
    status,
  } = verification.attributes;

  const isRedacted = redactedAt != null;

  const submitted = status !== VerificationStatus.Initiated;

  return (
    <ChecksInformationRow>
      <ChecksHeader title='Collected Fields' />
      <StyledAttributeGrid colCount={4}>
        <Attribute label='Country Code' value={countryCode} redacted={isRedacted} placeholder='-' />
        <Attribute label='VAT Number' value={vatNumber} redacted={isRedacted} placeholder='-' />
        <Attribute
          label='Business Name'
          value={businessName}
          redacted={isRedacted}
          placeholder='-'
        />
        <Attribute
          label='Address Street 1'
          value={addressStreet1}
          redacted={isRedacted}
          placeholder='-'
        />
        <Attribute
          label='Address Street 2'
          value={addressStreet2}
          redacted={isRedacted}
          placeholder='-'
        />
        <Attribute label='Address City' value={addressCity} redacted={isRedacted} placeholder='-' />
        <Attribute
          label='Address Subdivision'
          value={addressSubdivision}
          redacted={isRedacted}
          placeholder='-'
        />
        <Attribute
          label='Address Postal Code'
          value={addressPostalCode}
          redacted={isRedacted}
          placeholder='-'
        />
      </StyledAttributeGrid>
      <Divider />
      {submitted && <ChecksTable checks={checks as Check[]} verification={verification} />}
    </ChecksInformationRow>
  );
};

export default DatabaseVatNumberVerification;
